import { message } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../data/productCatalog';

const Footer = () => {
    const logoImg = "/logo.jpg";
    const [email, setEmail] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (email.trim() === "") {
            message.error('Email address is required.');
            return;
        }

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) {
            message.error('Please enter a valid email address.');
            return;
        }

        message.info('Sending...');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL_BACKEND}/api/v2/subscriber-email`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (response.ok) {
                setEmail("");
                const data = await response.json();
                message.success(data.message || 'Subscribed successfully!');
            } else {
                const errorData = await response.json();
                message.error(errorData.message || 'Unable to subscribe.');
            }
        } catch (error) {
            message.error(`Error: ${error.message}`);
        }
    };

    return (
        <footer className="footer-modern">
            <div className="footer-inner">
                <div className="footer-grid">
                    {/* Brand Column */}
                    <div>
                        <div className="footer-brand">
                            <img src={logoImg} alt="A Green Beginning" />
                            <span>{siteConfig.name}</span>
                        </div>
                        <p className="footer-desc">
                            Explore our lush collection of plants to elevate your living space.
                            From vibrant succulents to elegant ferns, find the perfect green companions.
                        </p>
                        <div className="footer-social">
                            <a href="https://www.facebook.com/k.laxmipriyanka" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a href="https://www.youtube.com/@agreenbeginningofficial" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                                <i className="fab fa-youtube"></i>
                            </a>
                            <a href="https://www.instagram.com/agreenbeginningofficial" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://github.com/dandurisrihari/agreenbeginningofficial" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                                <i className="fab fa-github"></i>
                            </a>
                        </div>
                    </div>

                    {/* Plants Column */}
                    <div className="footer-col">
                        <h5>Plants</h5>
                        <ul className="footer-links">
                            <li><Link to="/products/?category=live-plants">Live Plants</Link></li>
                            <li><Link to="/products/?category=indoor-plants">Indoor Plants</Link></li>
                            <li><Link to="/products/?category=flowering-seeds">Flowers & Seeds</Link></li>
                            <li><Link to="/products/?category=medicinal-plants">Medicinal</Link></li>
                            <li><Link to="/products/?category=vegetables">Vegetables</Link></li>
                        </ul>
                    </div>

                    {/* Useful Links Column */}
                    <div className="footer-col">
                        <h5>Useful Links</h5>
                        <ul className="footer-links">
                            <li><Link to="/products">All Products</Link></li>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/FAQ">FAQ</Link></li>
                            <li><Link to="/help">Help</Link></li>
                            <li><Link to="/contact-us">Contact Us</Link></li>
                        </ul>
                    </div>

                    {/* Contact + Newsletter Column */}
                    <div className="footer-col">
                        <h5>Contact Us</h5>
                        <div className="footer-contact-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>Southern India</span>
                        </div>
                        <div className="footer-contact-item">
                            <i className="fas fa-envelope"></i>
                            <a href="mailto:agreenbeginningstore@gmail.com">agreenbeginningstore@gmail.com</a>
                        </div>
                        <div className="footer-contact-item">
                            <i className="fas fa-phone"></i>
                            <a href="tel:+919717959956">+91 9717959956</a>
                        </div>

                        <h5 style={{ marginTop: '24px' }}>Newsletter</h5>
                        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '8px' }}>
                            <input
                                type="email"
                                placeholder="Your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{
                                    flex: 1,
                                    padding: '8px 14px',
                                    borderRadius: '999px',
                                    border: '1px solid rgba(255,255,255,0.15)',
                                    background: 'rgba(255,255,255,0.08)',
                                    color: 'white',
                                    fontSize: '0.85rem',
                                }}
                            />
                            <button
                                type="submit"
                                style={{
                                    padding: '8px 16px',
                                    borderRadius: '999px',
                                    background: '#2d7a4f',
                                    color: 'white',
                                    fontSize: '0.85rem',
                                    fontWeight: 600,
                                    border: 'none',
                                    cursor: 'pointer',
                                }}
                            >
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>

                <hr className="footer-divider" />
                <div className="footer-bottom">
                    <span>&copy; 2021-2026 <Link to="/">{siteConfig.name}</Link>. All rights reserved.</span>
                    <span>Made with 🌱 in India</span>
                </div>
            </div>
        </footer>
    );
};

export default React.memo(Footer);